import { token } from '@atlaskit/tokens';

export const visitedLinkColor: 'var(--ds-link-visited)' = token('color.link.visited');
